import { useState, useEffect, Fragment, useMemo, useLayoutEffect } from "react";
import { default as list } from "../../assets/images/list.svg";
import calendar from "../../assets/images/calendar-grey.png";
import trello from "../../assets/images/trello-grey.png";
import book from "../../assets/images/classs-img.png";
import arrowRight from "../../assets/images/arrow-right.png";
import meh from "../../assets/images/moji/meh.svg";
import smile from "../../assets/images/moji/smile.svg";
import MessageHollow from "../../assets/images/message-square-hollow.svg";
import Message from "../../assets/images/message-square.svg";
import frown from "../../assets/images/moji/frown.svg";
import Sidebar from "../../components/dashboard/Sidebar";
import { useDispatch } from "react-redux";
import Navbar from "../../components/dashboard/Navbar";
import Activity from "../../components/Activity";
import { Link } from "react-router-dom";
import { allClassesDetails } from "../../Store/api/professor/dashboard";
import DropDown from "../../components/dashboard/Tabs/Settings/Dropdown/DropDown";
import { bookChapters } from "../../Store/api/chapters";
import { CustomSelect } from "../../shared/CustomSelect";
import { IndicatorSeparator } from "../../components/dashboard/Tabs/Settings/Subsettings/ActivitySettings";
import { ActivityLoadingSkeleton } from "../../shared/ActivityLoadingSkeleton";

export const Activities = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState('all');
  const [chapters, setChapters] = useState([]);
  const [allClasses, setAllClasses] = useState([]);
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedActivity, setSelectedActivity] = useState();
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [selectedChapterOrders, setSelectedChapterOrders] = useState([]);

  useLayoutEffect(() => {
    dispatch(
      allClassesDetails({
        onSuccess: (res) => {
          setIsLoading(false);
          setAllClasses(res.data.data);
          setSelectedClass(res?.data?.data?.[0]?.courseNumber);
          const transformedArray = res.data.data.map((item) => {
            const { courseName, courseNumber, _id, numberOfStudents, allActivities } = item;
            const students = numberOfStudents;
            const flatAnswers = allActivities.reduce((uniqueActivities, activity) => {
              const isActivityUnique = !uniqueActivities.some((uniqueActivity) => uniqueActivity._id === activity._id);

              if (isActivityUnique) {
                uniqueActivities.push({
                  ...activity,
                  courseName,
                  courseNumber,
                  classId:_id,
                  students,
                });
              }

              return uniqueActivities;
            }, []);

            return flatAnswers;
          });
          let activitiesFlatten = [].concat(...transformedArray);
        
          setActivities(activitiesFlatten);
          setFilteredActivities(activitiesFlatten);
        },
        onError: () => {
          setIsLoading(false);
        },
        onEnd: () => setIsLoading(false),
      })
    );
  }, []);

  useLayoutEffect(() => {
    const currentDate = new Date();

    // Step 1: Filter activities based on class
    let activitiesToFilter = selectedClass ? activities.filter((e) => e.courseNumber === selectedClass) : activities;

    // Step 2: Further filter activities based on selected chapters
    if (selectedChapters.length > 0) {
      activitiesToFilter = activitiesToFilter.filter((e) => selectedChapters.includes(e.chapter._id));
    }

    // Step 3: Filter based on the current filter
    let filtered = activitiesToFilter.filter((activity) => {
      switch (filter) {
        case 'graded':
          return activity.activityAnswers.length && activity.activityAnswers.every((e) => e.isGraded);

        case 'submitted':
          return activity.activityAnswers.length && activity.activityAnswers.some((e) => e.answers.length && !e.isGraded);

        case 'next':
          return activity.activityAnswers.some((e) => !e.answers.length) && new Date(activity.assignedDate) > currentDate;

        case 'pastdue':
          return (!activity.activityAnswers.length || activity.activityAnswers.some((e) => !e.isGraded)) && new Date(activity.assignedDate) < currentDate;

        case 'all':
        default:
          return true;
      }
    });

    const ordersList = chapters.filter(item => selectedChapters.includes(item._id));
    setSelectedChapterOrders(ordersList.map(item => item.order));

    // Step 4: Update filteredActivities state
    setFilteredActivities(filtered);
    setSelectedActivity(); // Now called only once at the end
  }, [filter, activities, selectedClass, selectedChapters]);

  const options = useMemo(
    () =>
      allClasses?.map((cls) => ({
        label: cls.courseName + '  |  ' + cls.courseNumber,
        value: cls.courseNumber,
        isChecked: selectedClass === cls.courseNumber,
      })) || [],
    [allClasses, selectedClass]
  );

  useEffect(() => {
    const sClass = allClasses.find((e) => e.courseNumber === selectedClass);
    if (sClass) {
      dispatch(
        bookChapters({
          id: sClass.book,
          onSuccess: (res) => {
            setChapters(res.data.data);
          },
          onError: (err) => {},
        })
      );
    }
  }, [selectedClass, allClasses, dispatch]);  

  return (
    <div className='wrapper'>
      {/* <!-- Page Sidebar --> */}
      <Sidebar userType='teacher' sideBarEvent={'activities'} />
      {/* <!-- Page Content Holder --> */}
      <div id='content'>
        <div className='content_dashborad_inner'>
          {/* <!-- navbar --> */}

          <Navbar sideBarEvent='activities' />

          <div className='main_section_content '>
            <div className='center_content center_content_h90vh ' style={{ marginTop: '15px' }}>
              <div className='header_all_activity'>
                <div className='header_innder gap-3'>
                  <div className='d-flex align-items-center gap-3'>
                    <img className='cursor' src={list} alt='list' />
                    <img className='cursor' src={calendar} alt='calendar' />
                    <img className='cursor' src={trello} alt='trello' />
                  </div>
                  <div className='selct_box_main w-30'>
                    <div className='dropdown_wrapper_custom w-100'>
                      <CustomSelect 
                        customStyle={{
                          menu: (provided) => ({
                            ...provided,
                            marginTop: 0, // This removes the gap between control and dropdown
                            border: "1px solid grey"
                          }),
                        }} 
                        className='w-100' 
                        options={options} 
                        placeholder='Class Select' 
                        components={{ IndicatorSeparator }} 
                        handleChange={(event) => setSelectedClass(event.value)} 
                        value={options.filter((item) => item.value === selectedClass)?.[0]} 
                      />
                    </div>
                  </div>
                  <div className='selct_box_main mr-0 w-25'>
                    <div className='form-group w-100'>
                      <DropDown
                        options={chapters.map((e) => ({
                          value: e._id,
                          title: <span className='font-inter fs-14 mb-0 fw-500'>{`Chapter ${e.order}`}</span>,
                          isChecked: selectedChapters.includes(e._id),
                        }))}
                        title={!selectedChapterOrders.length ? 'Chapter select' : `Chapter ${selectedChapterOrders.length  ? selectedChapterOrders.join(", "): "Chapter select"}`}
                        onChange={(e) => {
                          setSelectedChapters((old) => (old.includes(e.target.value) ? old.filter((c) => c !== e.target.value) : [...old, e.target.value]));
                        }}
                        type='checkbox'
                        dropdownClassName='custom-dropdown-class m-0'
                      />
                    </div>
                  </div>
                </div>
                <div className='all_active_button'>
                  <button
                    type='button'
                    className={`${filter === 'all' ? 'active' : ''}`}
                    onClick={() => {
                      setFilter('all');
                    }}
                  >
                    All activities
                  </button>
                  <button
                    type='button'
                    className={`${filter === 'next' ? 'active' : ''}`}
                    onClick={() => {
                      setFilter('next');
                    }}
                  >
                    Upcoming
                  </button>
                  <button
                    type='button'
                    className={`${filter === 'submitted' ? 'active' : ''}`}
                    onClick={() => {
                      setFilter('submitted');
                    }}
                  >
                    Submitted
                  </button>
                  <button
                    type='button'
                    className={`${filter === 'pastdue' ? 'active' : ''}`}
                    onClick={() => {
                      setFilter('pastdue');
                    }}
                  >
                    Past due
                  </button>
                  <button
                    type='button'
                    className={`${filter === 'graded' ? 'active' : ''}`}
                    onClick={() => {
                      setFilter('graded');
                    }}
                  >
                    Graded
                  </button>
                </div>
              </div>

              {isLoading ? (
                [...new Array(6)].map((item) => <ActivityLoadingSkeleton key={item} />)
              ) : (
                <div className='activities_due_next p-0 '>
                  {filteredActivities.length ? (
                    <Fragment>
                      {filteredActivities.map((activity, index) => {
                        const currentDate = new Date();
                        const autoGraded = activity.questions.filter((e) => e.type === 'mcqs').length;
                        const teacherGraded = activity.questions.length - autoGraded;
                        const isGraded = activity.activityAnswers.length && activity.activityAnswers.findIndex((e) => !e.isGraded) === -1;
                        const isSubmitted = activity.activityAnswers.length && activity.activityAnswers.findIndex((e) => !e.isGraded && e.answers.length) > -1;
                        const isUpcomming = activity.activityAnswers.findIndex((e) => !e.answers.length) > -1 && new Date(activity.assignedDate) > currentDate;
                        const isPastDue = !isGraded && new Date(activity.assignedDate) < currentDate;
                        return (
                          <div
                            key={index}
                            className={`Definition_of_terms cursor ${selectedIndex === index ? 'selected_act' : ''}`}
                            onClick={() => {
                              setSelectedIndex(index);
                              setSelectedActivity({
                                ...activity,
                                owner: activity.owner || {
                                  firstName: 'John',
                                  lastName: 'Doe',
                                },
                                graded: activity.activityAnswers.filter((x) => x.isGraded).length,
                                total: activity.students,
                                status: isGraded ? 'completed' : isSubmitted ? 'submitted' : isUpcomming ? '' : isPastDue ? 'past' : '',
                              });
                            }}>
                            <div className="img_Wrap_book">
                              {" "}
                              <img
                                src={activity.book.coverImage || activity.book?.activityBookCoverUrl || book}
                                alt="book"
                              />{" "}
                            </div>
                            <div className='text_right'>
                              <div className='book_text' style={{ width: '40%' }}>
                                <h6 className='ft_12 fw-700'>
                                  {activity.courseName} {activity.courseNumber}
                                </h6>
                                <h5 className='ft_12 fw-500 mt_10'>
                                  <u>chapter {activity.chapter.order}</u>
                                </h5>
                                <h1 className='ft_18 fw-700 mt_10  mb-0'>{activity.title}</h1>{' '}
                              </div>
                              <div className='middle_text'>
                                <div>
                                  <b>{activity.activityAnswers?.filter((e) => !e.isSubmitted).length}</b> due
                                </div>
                                <div>
                                  <b>{activity.activityAnswers.filter((e) => e.answers.length).length}</b> submitted
                                </div>
                                <div>
                                  <b>{activity.activityAnswers.filter((x) => x.isGraded).length}</b> graded
                                </div>
                              </div>
                              <div className='book_text text-end'>
                                <h6 className='ft_12 fw-700'>
                                  <span>{activity.assignedDate ? activity.assignedDate.split('T')[0] : 'No Date'} - </span>
                                  <span className={`${isGraded ? 'text_grn' : isSubmitted ? 'txt_yellow' : isUpcomming ? '' : isPastDue ? 'txt_red' : ''}`}>{isGraded ? 'graded' : isSubmitted ? 'submitted' : isUpcomming ? 'upcomming' : isPastDue ? 'past due' : ''}</span>
                                </h6>
                                <h5 className='ft_12 fw-500 mt_10 mb-16'>
                                  {autoGraded ? `${autoGraded} auto-graded` : ''}, {teacherGraded ? `${teacherGraded} teacher-graded` : ''}{' '}
                                </h5>
                                <h5 className='ft_12 fw-500  mb-0'>
                                  <Link to={`/dashboard/gradding/${activity._id}/${activity?.classId}`} className='ft_12 fw-500  '>
                                    <u>{isSubmitted ? 'START' : 'VIEW'}</u>
                                  </Link>{' '}
                                  <a href='#!' className='ft_12 fw-500'>
                                    details
                                    <img src={arrowRight} alt='arrow-right' />
                                  </a>
                                </h5>{' '}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Fragment>
                  ) : (
                    <div className='no-activity no-actv'>No activities associated with book</div>
                  )}
                </div>
              )}
            </div>
            <div className='right_content feadback_box right_content_main mrl-0'>
              <div className={`box_border_settings ${selectedActivity ? 'date_Schedule' : `empty-act-height`}`}>
                {selectedActivity ? (
                  <>
                    <div className='head_line'>
                      <h1 className='ft_12 fw-700 d-flex'>
                        {selectedActivity.courseName}
                        <span className={`fw-700 ${selectedActivity.status === 'completed' ? 'text_grn' : selectedActivity.status === 'submitted' ? 'txt_yellow' : selectedActivity.status === 'upcomming' ? '' : selectedActivity.status === 'past' ? 'txt_red' : ''}`}>{selectedActivity.status}</span>
                      </h1>
                      <h5 className='d-flex align-items-center justify-content-between mb-20'>
                        <span>
                          <span className='right_content_Grade fw-400'>
                            {' '}
                            <b>
                              {selectedActivity.graded}/{selectedActivity.total}
                            </b>{' '}
                            graded
                          </span>
                        </span>{' '}
                        <a href={`/dashboard/gradding/${selectedActivity._id}/${selectedActivity?.classId}`} className='right_content_Grade  fw-500  '>
                          {' '}
                          <u className='fw-500  '>view</u>{' '}
                        </a>
                      </h5>
                    </div>
                    {isLoading ? (
                      'Loading...'
                    ) : (
                      <Fragment>
                        <div className='feedback_wrapper'>
                          <h3>
                            <img src={smile} alt='+ive' /> Positive feedback: 25 <img src={Message} alt='comment' />
                          </h3>
                          <p>
                            <b>Anna Biernacki:</b> This activity was fun!
                          </p>
                          <p>
                            <b>John Smith:</b> Easy way to learn something complicated.
                          </p>
                          <h3>
                            <img src={meh} alt='+ive' /> Neutral feedback: 3 <img src={MessageHollow} alt='comment' />
                          </h3>
                          <h3>
                            <img src={frown} alt='+ive' /> Negative feedback: 2 <img src={Message} alt='comment' />
                          </h3>
                          <p>
                            <b>John Smith:</b> Some of the questions were unclear.
                          </p>
                          <p>
                            <b>Jeff Johnson:</b> There was a spelling error in question 5. There was a spelling error in question 5.
                          </p>
                        </div>
                        <div className='dashboard_activities'>
                          <Activity activity={selectedActivity} index={0} from={'dashboard'} />
                        </div>
                      </Fragment>
                    )}
                  </>
                ) : (
                  <div className='right_content_Grade fw-400' style={{ textTransform: 'none' }}>
                    Select an activity to view details
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Activities;
